import pick from 'lodash/pick';

import {ChartType, FunnelBookmark} from 'common/report/funnels/models/types';
import {REPORT_LIMITS, ReportName} from 'common/report/constants';
import {QueryManager} from 'common/report/report-manager/query';
import {BaseQueryErrorType} from 'common/report/types';
import {FunnelQueryResponse, QueryType} from 'common/report/funnels/models/api-types';

export const ChartTypeToQueryType = {
  [ChartType.Chart]: QueryType.Main,
  [ChartType.Trends]: QueryType.Trends,
  [ChartType.Frequency]: QueryType.Frequency,
  [ChartType.TimeToConvert]: QueryType.TimeToConvert,
  [ChartType.Sankey]: QueryType.Sankey,
};

function getExtraQueryPostParams(params: FunnelBookmark, limit: number) {
  return {
    bookmark: {...params, limit},
    query_type: ChartTypeToQueryType[params.chart_type],
  };
}

export class FunnelsQueryManager extends QueryManager<FunnelBookmark, FunnelQueryResponse> {
  public reportName = ReportName.Funnels;
  public endpoint = `arb_funnels`;

  getExtraPostParams({bookmarkParams}: {bookmarkParams: FunnelBookmark}) {
    return getExtraQueryPostParams(bookmarkParams, REPORT_LIMITS[ReportName.Funnels].query);
  }

  getExtraCsvPostParams(bookmarkParams: FunnelBookmark) {
    return getExtraQueryPostParams(bookmarkParams, REPORT_LIMITS[ReportName.Funnels].csvExport);
  }

  transformBookmarkParams(bookmarkParams: FunnelBookmark) {
    return bookmarkParams;
  }

  public handleQueryError(err: BaseQueryErrorType) {
    return pick(err, [`data`, `status`, `error`]);
  }
}
